import React, { createContext, useContext, useMemo, useEffect } from "react";
import axios from "axios";

const ConfigContext = createContext({
  apiBaseUrl: "https://api.huay-huay.vip",
});

export const ConfigProvider = ({ children }) => {
  const apiBaseUrl =
    process.env.REACT_APP_API_BASE_URL || "https://api.huay-huay.vip";

  useEffect(() => {
    axios.defaults.baseURL = apiBaseUrl;
  }, [apiBaseUrl]);

  const value = useMemo(() => ({ apiBaseUrl }), [apiBaseUrl]);
  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);

export default ConfigContext;
